@if (src) {
  <img [src]="src" [alt]="alt" [style.height.px]="height" [ngClass]="{'height-on-small-screens height-on-tablet-screens' : isReducedHeight}" (error)="onError()">
} @else {
  <img src="/assets/images/camera.png" alt="No Image" [style.width.px]="height" />
}
